import { useFreebetsUsageTable } from '@Modal/hooks/freebetsUsage/useFreebetsUsage';
import { Button, Stack, Typography } from '@mui/material';

export const FreebetsUsageTitle: React.FC = () => {
  const { freebetUsageTableFilters, handleClearFreebetsUsageTableFilters } =
    useFreebetsUsageTable();
  const objectVals = Object.values(freebetUsageTableFilters);
  const disabled = objectVals.length === 0 || objectVals.every((val) => val === undefined);

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{ paddingBottom: 2 }}
    >
      <Typography variant="h3">Usage</Typography>
      <Button
        size="large"
        variant="contained"
        disabled={disabled}
        onClick={handleClearFreebetsUsageTableFilters}
      >
        Clear filters
      </Button>
    </Stack>
  );
};
